import {Component, h, Host, Prop, State, Element} from '@stencil/core';

export interface PageInfo {
  index: number,
  active?: boolean,
  title: string
}

@Component({
  tag: 'lb-form-navigation',
  styleUrl: 'nav-styles.scss',
  shadow: true,
})
export class FormNavigation {
  
  @Prop() pageInfos:PageInfo[];
  @Element() el;

  /**
   * i18n - "meta" texts in selected language
   */
  @Prop({mutable: true}) i18n;

  @State() expandAllItemsBeforeActive: boolean = false;
  @State() expandAllItemsAfterActive: boolean = false;

  getActiveIndex() { // trim page infos. show only first, last, previous and next page
    for(var i = 0; i < this.pageInfos.length; i++) {
      if (this.pageInfos[i].active) return i;
    }
  }

  shouldBeCollapsed(i) {
    const itemCount = this.pageInfos.length
    const activeIndex = this.getActiveIndex()
    
    // return true if item length smaller then 5
    if(itemCount <= 5) return false

    // return true if item is last item or even higher
    if(i >= itemCount) return false

    // return true if first or last item
    if (i === 0 || i === (itemCount-1)) return false

    // return true if current, previous or next item is active
    if (i === activeIndex || i === activeIndex +1 || i === activeIndex -1) return false

    // return true if expand before or after was set
    if (this.expandAllItemsBeforeActive && i < activeIndex) return false
    if (this.expandAllItemsAfterActive && i > activeIndex) return false      

    return true
  }

  isExpandTrigger(i) {
    return this.shouldBeCollapsed(i) && !this.shouldBeCollapsed(i-1);
  }

  toggleExpandAll() {
    const expand = !this.expandAllItemsBeforeActive || !this.expandAllItemsAfterActive;
    this.expandAllItemsBeforeActive = expand;
    this.expandAllItemsAfterActive = expand;
  }

  expand(i) {

    if (!this.isExpandTrigger(i)) return

    const activeIndex = this.getActiveIndex();
    // check which part shall be expanded
    if (i< activeIndex) {
      this.expandAllItemsBeforeActive = true;
      if (!this.isExpandTrigger(activeIndex+2)) {
        // if there is no "expand after"-trigger, also set expandAllItemsAfterActive to true
        this.expandAllItemsAfterActive = true;
      }
    }

    if (i > activeIndex) {
      this.expandAllItemsAfterActive = true;
      if (!this.isExpandTrigger(1)) {
        // if there is no "expand before"-trigger, also set expandAllItemsBeforeActive to true
        this.expandAllItemsBeforeActive = true;
      }
    }
  }

  componentDidRender() {
    if ( document.activeElement 
      && this.el.contains(document.activeElement) 
      && document.activeElement.tagName === 'A') 
      {
        (document.activeElement as HTMLAnchorElement).blur();
      }
  }

  render() {
    return (
      <Host>
        <nav data-testid="navigation-menu">
          <header>
            <h4>{ this.i18n?.headerText }</h4>
            {
            this.pageInfos?.length > 5 && (
            <button
              class="toggle-all"
              onClick={()=> this.toggleExpandAll() }
              onKeyUp={(evt)=> { if (evt.key === 'Enter') this.toggleExpandAll() }}     
              >{ this.expandAllItemsBeforeActive && this.expandAllItemsAfterActive ? this.i18n?.collapseAllText : this.i18n?.expandAllText }</button>
            )}
          </header>
          <ol>
          {
            this.pageInfos?.map(( page, i ) => (
              <li {... this.isExpandTrigger(i) ? {tabindex: 0} : {}}
                  {... this.shouldBeCollapsed(i) ? {class: 'collapsed'} : {}} 
                  onClick={()=> this.expand(i) }
                  onKeyUp={(evt)=> { if (evt.key === 'Enter') this.expand(i) }}>
                <a
                    {... this.shouldBeCollapsed(i) ? {tabindex: -1} : {}}
                    {... !page.active ? {href:'#' + page.index} : {}} 
                    title={ page.title }>
                  <span>{ page.title }</span></a>
              </li>              
            ))
          }
          </ol>
        </nav>
      </Host>
    );
  }
}
